import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { BinanceService } from 'src/app/modules/shared/services/binance/binance.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  storeDetail: any;
  shareLink = '';
  @ViewChild('shareLinkDialog') shareLinkDialog: any;
  constructor(
    public dialogRef: MatDialogRef<OrderDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private storeDetailResolver: StoreDetailService,
    private panelService: PanelService,
    private clipboard: Clipboard,
    private binanceService: BinanceService,
    private snackbarService: SnackBarService
  ) {}

  ngOnInit(): void {
    this.storeDetail = this.storeDetailResolver.permissionInit;
  }

  orderAgain() {
    this.dialogRef.close({
      orderAgain: true
    });
  }

  resendOrder() {
    const productId = this.data.product?.id;
    if (!productId) return;
    if (this.data?.product?.status == 6) {
      this.panelService
        .resendOrder(productId)
        .subscribe((res) =>
          this.snackbarService.showSnackBar(res.detail, 'primary', 3000)
        );
    }
  }

  viewOrder(id, type: number = 1) {
    if (this.data?.product?.status == 6) {
      this.shareLink = '';
      if (id) {
        this.panelService.getShareLink(id).subscribe((data) => {
          if (data.share_link) {
            if (type == 1) {
              this.copyToClipboard(data.share_link);
            } else {
              if (this.binanceService.isBinance) {
                window.location.href = data.share_link;
              } else {
                window.open(data.share_link, '_blank');
              }
            }
          }
        });
      }
    }
  }

  copyToClipboard(data: any) {
    this.clipboard.copy(data);
    let message = 'Link copied to clipboard.';
    this.snackbarService.showSnackBar(message, 'primary', 2000);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
